export abstract class Mapper<FormValues, Model, PayloadModel> {
	abstract mapToForm(data: Model): FormValues;
	abstract mapFormToPayload(formValues: Partial<FormValues>): Partial<PayloadModel>;
	mapModelToPayload?(data: Model): PayloadModel;

	mapToFormList(data: Model[]): FormValues[] {
		return data.map(this.mapToForm.bind(this));
	}
	mapFormToPayloadList(formValues: FormValues[]): Partial<PayloadModel>[] {
		return formValues.map(this.mapFormToPayload.bind(this));
	}

	mapModelToPayloadList(data: Model[]): PayloadModel[] {
		return this.mapModelToPayload ? data.map(this.mapModelToPayload.bind(this)) : [];
	}

	mapStringToEnum<T extends object>(value: string, enumObj: T) {
		return Object.values(enumObj).find(enumValue => enumValue === value) as T[keyof T] | undefined;
	}

	formatNumber(value: number | undefined, decimals: number, forceDecimals = false): string {
		if (typeof value === 'string') {
			value = parseFloat(value);
		}
		if (!value || isNaN(value)) {
			return '';
		}
		return Number.isSafeInteger(value) && !forceDecimals
			? value.toString()
			: value.toFixed(decimals);
	}
}
